import './i18n';
import './index.css';
import './styles/tippy.scss';

import App from './App';
import { createRoot } from 'react-dom/client';
import React from 'react';

const container = document.getElementById('root');
const root = createRoot(container!); // createRoot(container!) if you use TypeScript

const Root =
  process.env.NODE_ENV === 'development' ? (
    <App />
  ) : (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

root.render(Root);

export { filteringBySearch } from 'modules/organizers/domain/utils/filtering-by-search';
